export default __webpack_public_path__ + "static/img2-15897aa6353ffc01e8015f0b168ba6c1.png";